// extracted by mini-css-extract-plugin
var _1 = "I7XaZUmfACWSEkQwaO0H";
export { _1 as "breadCrumbTrail" }
